const BUNDLE_PREFIXES = ['com.songsnap.', 'com.appixi.songsnap.'];

/** Short label for App Store product IDs (Y-axis). Full id in chart tooltip. */
export const shortProductLabel = (productId, maxLen = 24) => {
  if (!productId) return '—';

  let name = productId;
  for (const prefix of BUNDLE_PREFIXES) {
    if (name.startsWith(prefix)) {
      name = name.slice(prefix.length);
      break;
    }
  }

  name = name.replace(/_/g, ' ');

  if (name.length <= maxLen) {
    return name;
  }

  const segments = productId.split('.');
  const last = segments[segments.length - 1]?.replace(/_/g, ' ');
  if (last && last.length <= maxLen) {
    return last;
  }

  return `${name.slice(0, maxLen - 1)}…`;
};

export const formatUsdLabel = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return '';
  if (n >= 1000) return `$${(n / 1000).toFixed(1)}k`;
  return `$${n.toFixed(2)}`;
};

/** YYYY-MM-DD to short local date for chart axis (avoids UTC shift). */
export const formatChartDayLabel = (dateValue) => {
  if (!dateValue) return '—';
  const parts = dateValue.split('-').map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return '—';
  const [year, month, day] = parts;
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};
